import { Component, Input, OnInit, TemplateRef, ViewChild, ElementRef, NgZone} from '@angular/core';
import { first } from 'rxjs';
import { ControlService } from 'src/app/services/control.service';
import { InstallService } from 'src/app/services/install.service';
import { LoginService } from 'src/app/services/login.service';
import { StorageService } from 'src/app/services/storage.service';
import { AutomationService } from 'src/app/services/automation.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule]
})
export class DashboardComponent implements OnInit {
  @ViewChild('alerttemplate') alertTemplate!: TemplateRef<any>;
  @ViewChild('lang_change_template') lang_change_template!: TemplateRef<any>;
  @ViewChild('alertWithCountdownTemplate') alertWithCountdownTemplate: TemplateRef<any>;
  @ViewChild('delete_file') deleteFileTemplate: TemplateRef<any>;
  fileToDelete: any; // Store the file to be deleted
  msg: string = "";
  focusUrl: boolean = false;
  selectedBrowser: any;
  modalRef!: MatDialogRef<any>;
  @Input() control: ControlService;
  @Input() device: any;
  //Modals
  @ViewChild('appInstall', { static: false }) myInputTagAppInstall: ElementRef;
  // @ViewChild('fileUpload', { static: false }) myInputTagFileUpload: ElementRef;
  // @ViewChild('filetoServer', { static: false }) myInputTagFiletoServer: ElementRef;
  manifestShow: boolean = false;
  manifestData: any;
  progressAppUpload: number = 0;
  successAppUpload: boolean = false;
  errorAppUpload: boolean = false;
  progressFileUpload: number = 0;
  selectedPackageName: any
  selectedFile: File | null = null;
  result: any = null;
  currentUser: any;
  appInstalling: boolean = false;
  // uploadApk :boolean =true;
  // Navigation
  textURL: any;
  activities: any;
  browser: any;
  command: string;
  data: any;
  urlFavicon: any;
  faviconIsSet: boolean = false;
  blurUrl: boolean = false;
  email: any;
  manifest: any
  //Upload file to server
  installation: any;
  showinstallation: boolean = false
  accordionOpen: any;
  shellShow: boolean = false;
  installationShow: boolean = false
  isPanelOpen: boolean = false
  titleAppupld: string;
  titleUpldSrvr: string;
  titleFileUpld: string;
  selectedActivityName: any
  showDropdownactivity: boolean = false;
  showDropdownactions: boolean = false;
  showDropdowncategory: boolean = false
  activityValue: string = '';
  actionsValue: string = '';
  categoryValue: string = '';
  intentFilters: any[];
  actions: any[]
  dataValue: string = ''
  category: any[]
  Data: any[]
  confirmYesCallback: Function | null = null;
  confirmNoCallback: Function | null = null;
  isConfirmation = false;
  selectedLangCode: string = '';
  searchText: string = '';
  timer: number = 5;
  showReconnectButton: boolean = false;
  intervalId: any;
  languageMap = {
    ur: 'Urdu',
    lt: 'Lithuanian',
    ja: 'Japanese',
    id: 'Indonesian',
    mr: 'Marathi',
    ms: 'Malay',
    hi: 'Hindi',
    'es-419': 'Latin American Spanish',
    es: 'Spanish',
    pl: 'Polish',
    ca: 'Catalan',
    ta: 'Tamil',
    fr: 'French',
    'en-IN': 'English (India)',
    or: 'Odia (Oriya)',
    'fr-CA': 'French (Canada)',
    da: 'Danish',
    bg: 'Bulgarian',
    te: 'Telugu',
    'kk-Cyrl': 'Kazakh (Cyrillic)',
    'pt-BR': 'Portuguese (Brazil)',
    'zh-Hant-HK': 'Traditional Chinese (Hong Kong)',
    hr: 'Croatian',
    gu: 'Gujarati',
    de: 'German',
    th: 'Thai',
    sk: 'Slovak',
    ro: 'Romanian',
    sl: 'Slovenian',
    nb: 'Norwegian Bokmål',
    kk: 'Kazakh',
    'en-GB': 'English (UK)',
    hu: 'Hungarian',
    'zh-HK': 'Chinese (Hong Kong)',
    bn: 'Bengali',
    ar: 'Arabic',
    it: 'Italian',
    kn: 'Kannada',
    ko: 'Korean',
    uk: 'Ukrainian',
    pa: 'Punjabi',
    ru: 'Russian',
    vi: 'Vietnamese',
    'zh-Hans': 'Simplified Chinese',
    'zh-Hant': 'Traditional Chinese',
    'en-AU': 'English (Australia)',
    ml: 'Malayalam',
    'pt-PT': 'Portuguese (Portugal)',
    tr: 'Turkish',
    fi: 'Finnish',
    'en-US': 'English (US)',
    el: 'Greek',
    cs: 'Czech',
    sv: 'Swedish',
    nl: 'Dutch',
    he: 'Hebrew',
    en: 'English',
    'es-US': 'Spanish (US)'
  };
  uploadSuccess: boolean = false;
  uploadMessage: string = '';
  isUploading: boolean = false;
  apiCalled: boolean = true;
  supportedLanguages = Object.keys(this.languageMap);
  showLangList = false;

  showDropdowndata: boolean = false;
  dumpydata: any[];
  leftColumnCards: string[] = [
    'appUpload',
    'fileUpload',
    'apps',
    'advancedInput',
    'maintenance',
    'navigation',
    'shell',
    'uploadFileToServer'
  ];  // rightColumnCards: any[] = [];
  uploadedFiles: any[] = [];
  isLoadingFiles: boolean = false;
  showFileHistory: boolean = false;
  constructor(
    private automationService: AutomationService,
    private dialog: MatDialog,
    private loginService: LoginService,
    private storageService: StorageService,
    private installService: InstallService,
    private router: Router,
    private commonService: CommonService,
    private zone: NgZone
  ) {
    this.loginService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit(): void {
    window.onbeforeunload = null;
    this.titleAppupld = "No file chosen";
    this.titleUpldSrvr = "No file chosen";
    this.titleFileUpld = "No file chosen";


    this.email = this.currentUser.email;
    this.installService.dataUpdated.subscribe((data: any) => {
      this.manifestData = data.manifest;


      if (data.success == true || data.success == "true")
        this.selectedPackageName = data.manifest.package
      this.activities = data.manifest.application.activities
      this.intentFilters = this.activities.flatMap(object => object.intentFilters)


      this.actions = this.intentFilters.flatMap(object => object.actions)
      this.dumpydata = this.intentFilters.flatMap(object => object.data)
      this.category = this.intentFilters.flatMap(object => object.categories)

      this.Data = this.dumpydata
        .filter(item => item.scheme)



      this.manifest = data.manifest
      this.installationShow = true
      // this.showinstallation = true
      this.isPanelOpen = true

    })

    this.installService.dataApkUpload.subscribe((data: any) => {
      this.zone.run(() => {
        let isIOSPlatform = this.device.platform == 'iOS';
        this.progressAppUpload = data.progress;

        if (data.progress == 100) {
          if (data.success) {
            this.successAppUpload = true;
            this.errorAppUpload = false;
            if (isIOSPlatform) {
              this.msg = "Successfully Installed, Tap Settings > General > VPN & Device Management. In the Enterprise App section, tap the name of the app developer. Tap Trust 'developer name' to continue."
              this.openAlertMod1(this.alertTemplate, this.msg);
            } else {
              this.showinstallation = true;
            }
            // Keep the green bar visible for 2 seconds then hide
            setTimeout(() => {
              this.zone.run(() => {
                this.appInstalling = false;
                this.successAppUpload = false;
              });
            }, 2000);
          } else {
            this.errorAppUpload = true;
            this.successAppUpload = false;
            this.msg = "Installation Failed: " + (data.error || "Unknown Error");
            this.openAlertMod1(this.alertTemplate, this.msg);
            // Keep red bar visible for a delay
            setTimeout(() => {
              this.zone.run(() => {
                this.appInstalling = false;
                this.errorAppUpload = false;
              });
            }, 5000);
          }
        }
      });
    })
    this.initializeCardLayouts();
    this.loadCardOrder();
  }

  private initializeCardLayouts() {
    const savedLayout = localStorage.getItem('dashboardLayout');
    const isIOSPlatform = this.device.platform === 'iOS';

    const iOSCards = ['advancedInput', 'appUpload', 'maintenance', 'uploadFileToServer', 'apps', 'navigation'];
    const allCards = ['appUpload', 'fileUpload', 'apps', 'advancedInput', 'maintenance', 'navigation', 'shell', 'uploadFileToServer'];

    if (savedLayout) {
      const layout = JSON.parse(savedLayout);
      if (isIOSPlatform) {
        this.leftColumnCards = layout.leftColumn.filter(card => iOSCards.includes(card));
      } else {
        this.leftColumnCards = layout.leftColumn;
      }
    } else {
      this.leftColumnCards = isIOSPlatform ? iOSCards : allCards;
    }
  }

  // Method to save card order
  private saveCardOrder() {
    // Save to localStorage
    try {
      localStorage.setItem('dashboardCardOrder', JSON.stringify(this.leftColumnCards));
    } catch (error) {
      console.error('Error saving card order:', error);
    }
  }
  // // Add these methods in your component
  // onFileClick(file: any) {
  //   // Show the file path in an alert
  //   this.msg = `File Path: ${file.path}`;
  //   this.openAlertMod1(this.alertTemplate, this.msg);
  // }

  copyFilePath(file: any, event: Event) {
    event.stopPropagation();
    navigator.clipboard.writeText(file.path).then(() => {
      this.msg = 'File path copied';
      this.openAlertMod1(this.alertTemplate, this.msg);
    }).catch(err => {
      this.msg = `Failed to copy file path`;
      this.openAlertMod1(this.alertTemplate, this.msg);
    });
  }
  loadUploadedFiles() {
    this.isLoadingFiles = true;
    const email = this.currentUser.email;
    const providerUrl = this.device.providerUrl;

    this.storageService.getUploadedFiles(email, providerUrl)
      .subscribe({
        next: (response) => {
          this.uploadedFiles = response.map(file => ({
            name: file.filename,
            path: file.absolute_path
          }));
          console.log("uploadedFiles: ",this.uploadedFiles,"\nresponse: ",response);
          
          this.isLoadingFiles = false;
        },
        error: (error) => {
          console.error('Error loading files:', error);
          this.uploadedFiles = [];
          this.isLoadingFiles = false;
        }
      });
  }
  toggleFileHistory() {
    this.showFileHistory = !this.showFileHistory;
    if (this.showFileHistory && this.uploadedFiles.length === 0) {
      this.loadUploadedFiles();
    }
  }
  // Method to load saved card order
  private loadCardOrder() {
    try {
      const savedOrder = localStorage.getItem('dashboardCardOrder');
      if (savedOrder) {
        this.leftColumnCards = JSON.parse(savedOrder);
      }
    } catch (error) {
      console.error('Error loading card order:', error);
    }
  }

  // Method to update layout
  private updateLayout() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }


  private saveLayout() {
    const layout = {
      leftColumn: this.leftColumnCards,
      // rightColumn: this.rightColumnCards
    };
    localStorage.setItem('dashboardLayout', JSON.stringify(layout));
  }


  // //handle unsaved changes popup while reloading
  // @HostListener('window:beforeunload', ['$event'])
  // handleBeforeUnload(event: BeforeUnloadEvent) {
  //   console.log("event reload:",event);
  //   event.preventDefault();
  //   event.returnValue = undefined;
  //   return;
  // }



  /*---------------------------------- Advanced/Navigation Section ----------------------------------*/
  press(key) {
    this.control.keyPress(key)
  }
  refresh() {
    let url = this.device.providerUrl;
    this.automationService.getPackageName(url, this.device.serial).pipe(first()).subscribe((res: any) => {

    });
  }
  // Modals
  rebootDeviceTemplate(template: TemplateRef<any>, event) {
    this.modalRef = this.dialog.open(template);
  }
  key(key: any) {
    if (this.device.ios) {
      this.control.keyPress(key)
      return
    }
    this.control.keyDown(key)
    this.control.keyUp(key)
  }
  reboot() {
    this.cancelRequest();
    let config = {
      rebootEnabled: true
    }

    if (config.rebootEnabled) {
      this.control.reboot(this.device).then((result) => {
        console.error(result)
      })
    }
  }
  cancelRequest() {
    this.modalRef.close();
  }
  /*---------------------------------- App (control buttons) ----------------------------*/

  run(cmd) {
    let command = cmd;
    // Force run activity
    command += ' --activity-clear-top'
    // return this.control.shell(command).then(function(result) {
    //     // console.log(result)
    //   })
    return this.control.shell(command);
  }

  runShell() {
    if (this.command == '') return;
    this.shellShow = true;
    this.control.shell(this.command).then((data: any) => {
      this.data = data.data;
    });
  }

  runActivity(): Promise<any> {
    let command: string = 'am start';
    //done
    if (this.actionsValue) {
      command += ' -a ' + this.actionsValue;
    }
    //done
    if (this.categoryValue) {
      command += ' -c ' + this.categoryValue;
    }

    if (this.dataValue) {
      command += ' -d ' + this.dataValue;
    }
    //done
    if (this.selectedPackageName && this.activityValue) {
      command += ' -n ' +
        this.selectedPackageName + '/' + this.activityValue;
    }

    return this.control.shell(command)
      .then((result: any) => {
        // console.log(result)
      });
  }

  openSetting(activity) {
    this.run('am start -a android.intent.action.MAIN -n com.android.settings/.Settings\\$' + activity);
  }

  openSettings() {
    if (this.device.ios)
      this.control.openSetting();
    else
      this.run('am start -a android.intent.action.MAIN -n com.android.settings/.Settings')
  }

  openWiFiSettings() {
    //openSetting('WifiSettingsActivity')
    this.run('am start -a android.settings.WIFI_SETTINGS')
  }

  onLanguageButtonClick() {
    if (this.device.ios) {
      this.showLangList = !this.showLangList;
    }
    else {
      this.openLanguageSettings();
    }
  }



  openLanguageSettings() {
    this.run('am start -a android.settings.LOCALE_SETTINGS');
  }

  selectLanguage(langCode: string) {
    this.selectedLangCode = langCode;
    this.modalRef = this.dialog.open(this.lang_change_template, { width: '300px' });
  }

  filteredLanguages(): string[] {
    return this.supportedLanguages.filter(lang =>
      (this.languageMap[lang] || lang)
        .toLowerCase()
        .includes(this.searchText.toLowerCase())
    );
  }

  // confirmLangChange() {
  //   this.modalRef.close();
  //   this.control.keyPress(this.selectedLangCode);
  //   location.reload();
  // }

  confirmLangChange() {
    this.modalRef.close();
    this.control.keyPress(this.selectedLangCode);

    this.msg = 'Restarting your phone with the updated language...';
    this.showReconnectButton = false;
    this.timer = 10;

    this.modalRef = this.dialog.open(this.alertWithCountdownTemplate, { width: '500px' });

    this.intervalId = setInterval(() => {
      this.timer--;
      if (this.timer <= 0) {
        clearInterval(this.intervalId);
        this.showReconnectButton = true;

        this.msg = 'The device should be ready. Click "Try to reconnect" to continue.';
      }
    }, 1000);
  }


  reconnect() {
    location.reload();
  }

  cancelLangChange() {
    this.modalRef.close();
    this.showLangList = false;
  }

  ok() {
    window.location.reload()
  }
  second() {
    this.modalRef.close();
    this.commonService.setActiveTab('/devices');
    this.router.navigate(['/devices']); // navigate
  }



  openLocaleSettings() {
    this.openSetting('LocalePickerActivity')
  }

  openIMESettings() {
    this.openSetting('KeyboardLayoutPickerActivity')
  }

  openDisplaySettings() {
    this.openSetting('DisplaySettingsActivity')
  }

  openDeviceInfo() {
    this.openSetting('DeviceInfoSettingsActivity')
  }

  openManageApps() {
    this.run('am start -a android.settings.APPLICATION_SETTINGS')
  }

  openRunningApps() {
    this.openSetting('RunningServicesActivity')
  }

  openDeveloperSettings() {
    // openSetting('DevelopmentSettingsActivity')
    this.run('am start -a android.settings.APPLICATION_DEVELOPMENT_SETTINGS')
  }

  clear() {
    this.shellShow = false

    this.command = '';

    // this.showinstallation = false
    // this.isPanelOpen = false
    // this.command = ''
    // this.data = ''
    // this.result = null
  }

  clearUninstall() {
    this.showinstallation = false
    this.isPanelOpen = false
    this.appInstalling = false;

  }
  clearFileUpload() {
    this.uploadSuccess = false;
    this.uploadMessage = '';
    this.progressFileUpload = 0;
  }

  /*---------------------------------- Navigation ----------------------------*/

  clearSettings() {
    let browser = this.browser;
    this.textURL = ""
    this.control.clearBrowser(browser)
  }

  openURL() {
    this.blurUrl = true
    // $rootScope.screenFocus = true
    let url = this.addHttp(this.textURL)
    this.setUrlFavicon(url)
    return this.control.openBrowser(url, this.browser)
  }

  onBrowserChange(browser: any): void {
    this.browser = browser;
  }

  trackByBrowserId(index: number, browser: any): number {
    return browser.id;
  }

  setUrlFavicon(url) {
    let FAVICON_BASE_URL = '//www.google.com/s2/favicons?domain_url='
    this.urlFavicon = FAVICON_BASE_URL + url
    this.faviconIsSet = true
  }

  addHttp(textUrl) {
    // Check for '://' because a protocol-less URL might include
    // a username:password combination.
    // Ignores also any query parameter because it may contain a http:// inside.
    return (textUrl.replace(/\?.*/, '').indexOf('://') === -1 ? 'http://' : ''
    ) + textUrl
  }

  setCurrentBrowser(browser) {
    if (browser && browser.apps) {
      let currentBrowser = {}
      if (browser.selected) {
        let selectedBrowser = _.head(browser.apps, 'selected')
        if (!_.isEmpty(selectedBrowser)) {
          currentBrowser = selectedBrowser
        }
      } else {
        let defaultBrowser = _.find(browser.apps, { name: 'Browser' })
        if (defaultBrowser) {
          currentBrowser = defaultBrowser
        } else {
          currentBrowser = _.head(browser.apps)
        }
      }
      this.browser = currentBrowser;
    }
  }

  resetFavicon() {
    // this.urlFavicon = require('./default-favicon.png') < ----- check
    this.faviconIsSet = false
  }

  /*---------------------------------- Upload file to server ----------------------------*/

  clearUploadFileToServer() {
    this.installation = null
    this.accordionOpen = false
  }

  // $scope.$on('installation', function(e, installation) {
  //   $scope.installation = installation.apply($scope)
  // })

  // public installUrl(url) {
  //   return this.installService.installUrl(this.control, url)
  // }

  // public fileUpload(event) {
  //   const email = this.currentUser.email;
  //   const url = this.device.providerUrl;
  //   const uploadedFile = event.target.files[0];
  //   this.titleUpldSrvr = uploadedFile.name;
  //   if (uploadedFile.length != 0) {
  //     return this.storageService.fileUploadToServer(uploadedFile, email, url);
  //   }
  // }

  public fileUploadToServer(event): boolean {
  const uploadedFile: File = event.target.files?.[0];
  if (!uploadedFile) {
    return false; // no file selected
  }

  const fileName = uploadedFile.name.toLowerCase();
  this.titleUpldSrvr = uploadedFile.name;

  const allowedMobileExtensions = ['.ipa', '.apk'];
  const isAllowedMobileFile = allowedMobileExtensions.some(ext =>
    fileName.endsWith(ext)
  );

  const hasForbiddenExt = this.forbiddenExtensions.some(ext =>
    fileName.endsWith(ext)
  );

  const doubleExtension = fileName.match(/\.[^.]+\.[^.]+$/);

  if (!isAllowedMobileFile && (hasForbiddenExt || doubleExtension)) {
    this.msg = 'File type not allowed. Please upload a valid file.';
    this.openAlertMod1(this.alertTemplate, this.msg);

    event.target.value = '';
    return false; // validation failed
  }

  const email = this.currentUser.email;
  const url = this.device.providerUrl;

  this.storageService.fileUploadToServer(uploadedFile, email, url)
    .subscribe({
      next: (response) => {
        this.msg = response.message || 'File uploaded successfully.';
        this.openAlertMod(this.alertTemplate, this.msg);
      },
      error: () => {
        this.msg = 'Server upload failed. Please try again.';
        this.openAlertMod1(this.alertTemplate, this.msg);
      }
    });

  return true; // upload initiated successfully
}


  public confirmDeleteFile(file: any, event: Event) {
    event.stopPropagation();
    this.fileToDelete = file; // Store the file reference
    this.modalRef = this.dialog.open(this.deleteFileTemplate);
  }

  public deleteFile() {
    if (!this.fileToDelete) return;
    this.modalRef.close();

    const email = this.currentUser.email;
    const filename = this.fileToDelete.filename || this.fileToDelete.name;
    const url = this.device.providerUrl;

    this.storageService.deleteFileFromServer(filename, email, url)
      .subscribe({
        next: (response) => {
          this.fileToDelete = null;
          this.uploadedFiles = this.uploadedFiles.filter(f =>
            (f.filename || f.name) !== filename
          );
          this.loadUploadedFiles();
          setTimeout(() => {
            this.msg = response.message || 'File deleted successfully.';
            this.openAlertMod(this.alertTemplate, this.msg);
          }, 100);
        },
        error: (error) => {
          this.fileToDelete = null;
          setTimeout(() => {
            this.msg = 'File deletion failed. Please try again.';
            this.openAlertMod1(this.alertTemplate, this.msg);
          }, 100);
        }
      });
  }

  public cancelFileDelete() {
    this.fileToDelete = null;
    this.modalRef.close();
  }



  resetInputFiletoServer() {
    // this.myInputTagFiletoServer.nativeElement.value = '';
  }


  installFile(file, device: any) {


    // if (file.type === 'application/vnd.android.package-archive') 
    if (file.name.endsWith('.apk') || file.name.endsWith('.ipa')) {
      // Process the file upload

      // this.uploadApk =false;
      this.appInstalling = true
      this.progressAppUpload = 0
      this.successAppUpload = false
      this.errorAppUpload = false
      return this.installService.installFile(this.control, file, device)

    } else {
      this.msg = "Please select a valid APK file or IPA file.";
      this.openAlertMod(this.alertTemplate, this.msg);
      this.titleAppupld = "No file chosen";
      return null;
    }


    // }
  }

  uninstall(packageName: any) {
    this.progressAppUpload = 0;
    this.showinstallation = false;

    this.titleAppupld = "No file chosen"
    return this.control.uninstall(packageName)
      .then(() => {
        this.clearUninstall();
      })
  }

  installUrl(url) {
    return this.installService.installUrl(this.control, url)
  }

  forbiddenExtensions = [
    '.exe', '.bat', '.cmd', '.com', '.msi', '.scr', '.ps1',
    '.sh', '.bash', '.csh', '.zsh', '.ksh',

    '.php', '.php3', '.php4', '.php5', '.phtml',
    '.asp', '.aspx', '.ashx', '.asmx',
    '.jsp', '.jspx', '.war',
    '.py', '.pyc', '.pyo', '.pyw',
    '.pl', '.cgi',
    '.rb', '.erb',

    '.env', '.htaccess', '.htpasswd',
    '.sql', '.log', '.ini', '.config',
    '.yaml', '.yml', '.json', '.xml',

    '.lnk', '.url', '.desktop'
  ];

  // fileUploadToDevice(event) {


  //   const file: File = event.target.files[0];
  //   this.titleFileUpld = file.name;
  //   this.selectedFile = file;

  //   this.storageService.uploadFile(file, this.device.serial, this.device.providerUrl, this.email)
  // }

  // fileUploadToDevice(event: any) {
  //   const file: File = event.target.files[0];

  //   if (!file) return;

  //   const fileName = file.name.toLowerCase();

  //   const hasForbiddenExtension = this.forbiddenExtensions.some(ext => fileName.endsWith(ext));

  //   const doubleExtension = fileName.match(/\.[^\.]+\.[^\.]+$/);

  //   if (hasForbiddenExtension || doubleExtension) {
  //     this.msg = 'File type not allowed. Please upload a valid file.';
  //     this.openAlertMod1(this.alertTemplate, this.msg);
  //     event.target.value = '';
  //     return;
  //   }

  //   this.titleFileUpld = file.name;
  //   this.selectedFile = file;

  //   try {
  //   this.storageService.uploadFile(file, this.device.serial, this.device.providerUrl, this.email);

  //   this.msg = 'Succesfully Uploaded to: /storage/emulated/0/Download/';
  //   this.openAlertMod1(this.alertTemplate, this.msg);
  // } catch (error) {
  //   this.msg = 'Upload failed. Please try again.';
  //   this.openAlertMod1(this.alertTemplate, this.msg);
  // }
  // }

  //   fileUploadToDevice(event: any) {
  //     const file: File = event.target.files[0];

  //     if (!file) return;

  //     const fileName = file.name.toLowerCase();

  //     const hasForbiddenExtension = this.forbiddenExtensions.some(ext => fileName.endsWith(ext));

  //     const doubleExtension = fileName.match(/\.[^\.]+\.[^\.]+$/);

  //     if (hasForbiddenExtension || doubleExtension) {
  //       this.msg = 'File type not allowed. Please upload a valid file.';
  //       this.openAlertMod1(this.alertTemplate, this.msg);
  //       event.target.value = '';
  //       return;
  //     }

  //     this.titleFileUpld = file.name;
  //     this.selectedFile = file;

  //     try {
  //       this.storageService.uploadFile(file, this.device.serial, this.device.providerUrl, this.email);

  //       // Set success state for card display
  //       this.uploadSuccess = true;
  //       this.uploadMessage = 'Successfully Uploaded, Check your file in the Downloads folder';

  //       // Optional: Hide success message after 5 seconds
  //       setTimeout(() => {
  //         this.uploadSuccess = false;
  //       }, 5000);

  //     } catch (error) {
  //       this.msg = 'Upload failed. Please try again.';
  //       this.openAlertMod1(this.alertTemplate, this.msg);
  //     }
  // }

  // fileUploadToDevice(event: any) {
  //   const file: File = event.target.files[0];

  //   if (!file) return;

  //   const fileName = file.name.toLowerCase();

  //   const hasForbiddenExtension = this.forbiddenExtensions.some(ext => fileName.endsWith(ext));
  //   const doubleExtension = fileName.match(/\.[^\.]+\.[^\.]+$/);

  //   if (hasForbiddenExtension || doubleExtension) {
  //     this.msg = 'File type not allowed. Please upload a valid file.';
  //     this.openAlertMod1(this.alertTemplate, this.msg);
  //     event.target.value = '';
  //     return;
  //   }

  //   this.titleFileUpld = file.name;
  //   this.selectedFile = file;

  //   // ✅ Start progress tracking
  //   this.isUploading = true;
  //   this.progress = 0;

  //   const interval = setInterval(() => {
  //     if (this.progress < 100) {
  //       this.progress += 10;
  //     } else {
  //       clearInterval(interval);
  //       this.isUploading = false;
  //       this.uploadSuccess = true;
  //       this.uploadMessage = 'Successfully Uploaded, Check your file in the Downloads folder';

  //       // Optional: Reset after 5 seconds
  //       setTimeout(() => {
  //         this.uploadSuccess = false;
  //       }, 5000);
  //     }
  //   }, 500);

  //   try {
  //     this.storageService.uploadFile(file, this.device.serial, this.device.providerUrl, this.email);
  //   } catch (error) {
  //     clearInterval(interval);
  //     this.isUploading = false;
  //     this.uploadSuccess = false;
  //     this.msg = 'Upload failed. Please try again.';
  //     this.openAlertMod1(this.alertTemplate, this.msg);
  //   }
  // }

  fileUploadToDevice(event: any) {
    const file: File = event.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const hasForbiddenExtension = this.forbiddenExtensions.some(ext => fileName.endsWith(ext));
    const doubleExtension = fileName.match(/\.[^\.]+\.[^\.]+$/);

    if (hasForbiddenExtension || doubleExtension) {
      this.msg = 'File type not allowed. Please upload a valid file.';
      this.openAlertMod1(this.alertTemplate, this.msg);
      event.target.value = '';
      return;
    }

    this.titleFileUpld = file.name;
    this.selectedFile = file;

    // Start progress tracking
    this.isUploading = true;
    this.progressFileUpload = 0;
    this.uploadSuccess = false;

    let progressInterval: any;

    // Start progress increment (10% every second until 90%)
    const startProgressIncrement = () => {
      progressInterval = setInterval(() => {
        if (this.progressFileUpload < 90) {
          this.progressFileUpload += 15;
          console.log('Progress:', this.progressFileUpload); // Debug log
        } else {
          // Stop at 90% and wait for API response
          clearInterval(progressInterval);
        }
      }, 100); // 0.1 second intervals
    };

    // Start the progress after threat check passes
    startProgressIncrement();
    this.uploadMessage = 'Upload failed. Please try again.';

    // Wait 650 milliseconds before making the API call
    setTimeout(() => {
      try {
        // Call the upload service and wait for response
        this.storageService.uploadFile(file, this.device.serial, this.device.providerUrl, this.email)
          .then((response) => {
            // API call successful - complete the progress
            clearInterval(progressInterval);
            this.progressFileUpload = 100;
            this.isUploading = false;
            this.uploadSuccess = true;
            this.apiCalled = false;
            this.uploadMessage = 'Successfully Uploaded, Check your file in the Downloads folder';

            // Reset success message after 3 seconds
            setTimeout(() => {
              this.uploadSuccess = false;
            }, 3000);
          })
          .catch((error) => {
            // API call failed
            clearInterval(progressInterval);
            this.isUploading = false;
            this.uploadSuccess = false;
            this.apiCalled = false;
            setTimeout(() => {
              this.progressFileUpload = 0;
            }, 3000);
            this.uploadMessage = 'Upload failed. Please try again.';
            // this.msg = 'Upload failed. Please try again.';
            // this.openAlertMod1(this.alertTemplate, this.msg);
          });

      } catch (error) {
        clearInterval(progressInterval);
        this.isUploading = false;
        this.uploadSuccess = false;
        this.apiCalled = false;
        setTimeout(() => {
          this.progressFileUpload = 0;
        }, 3000);
        this.uploadMessage = 'Upload failed. Please try again.';
        // this.msg = 'Upload failed. Please try again.';
        // this.openAlertMod1(this.alertTemplate, this.msg);
      }
    }, 600); // 2 second delay before API call
  }

  alertFileUpload() {
    this.msg = "Succesfully Uploaded, Check your file in the Downloads folder";
    this.openAlertMod(this.alertTemplate, this.msg);
  }

  alertFileUploadMsg(msg: string) {
    this.msg = msg;
    this.openAlertMod(this.alertTemplate, this.msg);
  }

  resetInputFileUpload() {
    // this.myInputTagFileUpload.nativeElement.value = '';
  }

  appUploadToDevice(event: any) {
    // Prevent file selection if already uploading
    if (this.appInstalling) {
      this.msg = "Please wait for the current upload to complete before selecting another file.";
      this.openAlertMod(this.alertTemplate, this.msg);
      return;
    }

    if (this.currentUser.userObj.appInstallationPrivilege == 'true' ||
      this.currentUser.userObj.appInstallationPrivilege == true ||
      this.currentUser.userObj.privilege == "admin") {
      const file = event.target.files[0] as File;

      // Additional check to ensure file is selected
      if (!file) {
        return;
      }

      this.titleAppupld = file.name;
      this.installFile(file, this.device);
    } else {
      this.msg = "You don't have permission to install the apk. Please contact to admin";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
  }


  resetInputAppInstall() {
    // Only reset if not currently uploading
    if (!this.appInstalling) {
      this.myInputTagAppInstall.nativeElement.value = '';
    }
  }

  toggleOpen() {
    this.isPanelOpen = !this.isPanelOpen
  }

  clearapk() {
    // Only allow clearing if not currently uploading
    if (!this.appInstalling) {
      this.installationShow = false;
      this.progressAppUpload = 0;
      this.appInstalling = false;
      this.showinstallation = false;
      this.isPanelOpen = false;
      this.titleAppupld = '';

      // Reset the file input
      if (this.myInputTagAppInstall) {
        this.myInputTagAppInstall.nativeElement.value = '';
      }
    } else {
      this.msg = "Cannot clear while upload is in progress. Please wait for upload to complete.";
      this.openAlertMod(this.alertTemplate, this.msg);
    }
  }


  onItemSelectactivity(activity: any) {
    this.activityValue = activity;

  }

  onItemSelectactions(actions: any) {
    this.actionsValue = actions

  }
  onItemSelectcategory(category: any) {

    this.categoryValue = category;


  }
  onItemSelectdata(data: any) {
    this.dataValue = data;
  }
  onBlur() {
    setTimeout(() => {
      this.showDropdownactions = false;
      this.showDropdowncategory = false;
      this.showDropdownactivity = false;
      this.showDropdowndata = false;

    }, 200);
  }
  onInputFocusCategory() {
    this.showDropdowncategory = true
  }
  onInputFocusActions() {
    this.showDropdownactions = true;

  }
  onInputFocusActivity() {
    this.showDropdownactivity = true;

  }
  onInputFocusData() {

    this.showDropdowndata = true;
  }

  openManifest() {
    this.manifestShow = !this.manifestShow;
  }

  openAlertMod(template: TemplateRef<any>, message: any) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    setTimeout(() => {
      this.modalRef.close();;
      this.msg = "";
    }, 2000)
  }

  // openAlertMod1(template: TemplateRef<any>, message: any) {
  //   this.modalRef = this.dialog.open(template, { width: '300px' });
  //   this.msg = message;
  // }
  openAlertMod1(template: TemplateRef<any>, message: any, isConfirm: boolean = false, onYes?: () => void, onNo?: () => void) {
    this.modalRef = this.dialog.open(template, { width: '300px' });
    this.msg = message;
    this.isConfirmation = isConfirm;

    if (isConfirm) {
      this.confirmYesCallback = onYes || null;
      this.confirmNoCallback = onNo || null;
    } else {
      // reset if it's just an alert
      this.confirmYesCallback = null;
      this.confirmNoCallback = null;
    }
  }

  Ok() {
    this.modalRef.close();;
    this.msg = "";
  }
}